import { render, staticRenderFns } from "./payment-page.vue?vue&type=template&id=24e784e5&scoped=true"
import script from "./payment-page.vue?vue&type=script&lang=ts"
export * from "./payment-page.vue?vue&type=script&lang=ts"
import style0 from "./payment-page.pcss?vue&type=style&index=0&id=24e784e5&prod&lang=postcss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e784e5",
  null
  
)

export default component.exports